// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/mission-launch/shared/CompletionBanner.jsx

import React from 'react';

export default function CompletionBanner({
  title,
  lead,
  description,
  eyebrow = 'Mission Ready',
  children,
}) {
  return (
    <section className="completion-banner">
      <div className="completion-banner-pulse" aria-hidden="true" />
      <div className="completion-banner-mission-icon" aria-hidden="true">
        <span className="completion-banner-mission-icon-orbit" />
        <span className="completion-banner-mission-icon-mark">O</span>
        <span className="completion-banner-mission-icon-check">✓</span>
      </div>
      {eyebrow ? <p className="mission-launch-eyebrow completion-banner-eyebrow">{eyebrow}</p> : null}
      <h2>{title}</h2>
      {lead ? <p className="completion-banner-lead">{lead}</p> : null}
      {description ? <p className="completion-banner-description">{description}</p> : null}
      {children ? <div className="completion-banner-actions">{children}</div> : null}
    </section>
  );
}
